export const TERRIFIC_USER_ID = 'terrificUserId';
